import { makeStyles, createStyles } from '@material-ui/core/styles';

const SwitchRoomsStyles = makeStyles((theme: any) => createStyles({
  closeIconButton: {
    position: "absolute",
    padding: 3,
    right: 5,
    top: 5,
  },
  arrowUpIcon: {
    fontSize: 30,
  },
  switchRoomsText: {
    fontSize: 14,
    position: "relative",
    textAlign: "left",
    left: 11,
    marginBottom: 10,
  },
  enterIcon: {
    position: "relative",
    left: 10,
  },
  switchRoomsTextHeader: {
    fontWeight: "bold",
  }
})
)

export { SwitchRoomsStyles };